import React from "react";
import { render } from "react-dom";

import App from "./App";
import "./i18n";

const element: any = <App />;

render(element, document.getElementById("root"));
